import React from 'react'
import { useThemeContext } from '@sketch/global-styles'
import { Flex, useBreakpoint, useResponsiveDropdown } from '@sketch/components'
import { StyledDropdownItem, Icon, ArrowIcon } from './UserDropdown.styles'
import { ReactComponent as ContrastIcon } from '@sketch/icons/contrast-16'
import { ReactComponent as SunIcon } from '@sketch/icons/sun-16'
import { ReactComponent as MoonIcon } from '@sketch/icons/moon-16'
import { ReactComponent as DeviceDesktopIcon } from '@sketch/icons/device-desktop-16'
import { MobileNavigationHeader } from './AppearanceMenu.styles'

type AppearanceMenuContentProps = {
  isLight: boolean
  isDark: boolean
  matchSystem: boolean
  enableLightMode: () => void
  enableDarkMode: () => void
  toggleMatchSystem: () => void
}

const AppearanceMenuContent = ({
  isLight,
  isDark,
  matchSystem,
  enableLightMode,
  enableDarkMode,
  toggleMatchSystem,
}: AppearanceMenuContentProps) => {
  const isMobileAndBigger = useBreakpoint('xs')

  return (
    <>
      {!isMobileAndBigger && (
        <MobileNavigationHeader>Appearance</MobileNavigationHeader>
      )}
      <StyledDropdownItem $isActive={isLight} onClick={enableLightMode}>
        <Icon $isActive={isLight} as={SunIcon} />
        Light
      </StyledDropdownItem>
      <StyledDropdownItem $isActive={isDark} onClick={enableDarkMode}>
        <Icon $isActive={isDark} as={MoonIcon} />
        Dark
      </StyledDropdownItem>
      <StyledDropdownItem $isActive={matchSystem} onClick={toggleMatchSystem}>
        <Icon $isActive={matchSystem} as={DeviceDesktopIcon} />
        System Default
      </StyledDropdownItem>
    </>
  )
}

export const AppearanceMenu = () => {
  const {
    enableLightMode,
    enableDarkMode,
    toggleMatchSystem,
    theme,
    matchSystem,
  } = useThemeContext()

  const isLight = !matchSystem && theme === 'light'
  const isDark = !matchSystem && theme === 'dark'
  const POPOVER_OFFSET = [0, 0] as [number, number]

  const [content, buttonProps] = useResponsiveDropdown({
    dropdown: AppearanceMenuContent,
    placement: 'right-end',
    dropdownProps: {
      enableLightMode,
      enableDarkMode,
      toggleMatchSystem,
      isDark,
      isLight,
      matchSystem,
    },
    showOnHover: true,
    usePortal: true,
    offset: POPOVER_OFFSET,
  })

  return (
    <>
      <StyledDropdownItem {...buttonProps}>
        <Flex width="100%" justifyContent="space-between" alignItems="flex-end">
          <Flex alignItems="flex-end">
            <Icon as={ContrastIcon} /> Appearance
          </Flex>
          <ArrowIcon />
        </Flex>
      </StyledDropdownItem>
      {content}
    </>
  )
}
